import User from './user';
export default class Booking {
    id;
    uuid;
    user;
    expanded_user;
    first_name;
    last_name;
    email;
    phone;
    start_date;
    end_date;
    cabin;
    payed;
    replied;
    notes;
    price;
    has_plus_one;
    created;

    constructor(dict) {
        this.id = dict["id"];
        this.uuid = dict["uuid"];
        this.first_name = dict["first_name"];
        this.last_name = dict["last_name"];
        this.email = dict["email"];
        this.phone = dict["phone"];
        this.user = dict["user"];
        if (dict["expanded_user"] != null) {
            this.expanded_user = new User(dict["expanded_user"]);
        } else {
            this.expanded_user = null
        }
        this.start_date = new Date(dict["start_date"]);
        this.end_date = new Date(dict["end_date"]);
        //this.start_date.setHours(12);
        //this.end_date.setHours(12);
        this.cabin = dict["cabin"];
        this.payed = dict["payed"];
        this.replied = dict["replied"];
        this.notes = dict["notes"];
        this.price = dict["price"];
        this.has_plus_one = dict["has_plus_one"];
        this.created = new Date(dict["created"]);
    }

    toDict() {
        return {
            "user" : this.user,
            "first_name" : this.first_name,
            "last_name" : this.last_name,
            "email" : this.email,
            "phone" : this.phone,
            "start_date" : this.start_date,
            "end_date" : this.end_date,
            "cabin" : this.cabin,
            "payed" : this.payed,
            "replied" : this.replied,
            "notes" : this.notes,
            "price" : this.price,
            "has_plus_one" : this.has_plus_one
        };
    }

    getCabin() {
        if (this.cabin == 1) {
            return "Storstugan"
        } else if (this.cabin == 2) {
            return "Lillstugan"
        } else {
            return "Familjelägenheten"
        }
    }

    getFullName() {
        const first_name = this.expanded_user != null ? this.expanded_user.first_name : this.first_name
        const last_name = this.expanded_user != null ? this.expanded_user.last_name : this.last_name
        return first_name + " " + last_name
    }

    getEmail() {
        return this.expanded_user != null ? this.expanded_user.email : this.email
    }

    getPhone() {
        return this.expanded_user != null ? this.expanded_user.phone : this.phone
    }

    getCreatedDateString() {
        return this.created.toLocaleDateString("sv-SE")
    }

    getStartDateString() {
        return this.start_date.toLocaleDateString("sv-SE")
    }

    getEndDateString() {
        return this.end_date.toLocaleDateString("sv-SE")
    }

    getDateRange() {
        return this.start_date.toLocaleDateString("sv-SE") + " - " + this.end_date.toLocaleDateString("sv-SE")
    }
}
